"use client";

import { alertIconByVariant } from "@/components/ui/alert";
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast";
import { useToast } from "@/components/ui/use-toast";

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        const Icon = alertIconByVariant[props.variant ?? "info"];

        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              <div className="inline-flex items-center gap-2">
                <div>
                  <Icon />
                </div>
                {/* eslint-disable-next-line @typescript-eslint/strict-boolean-expressions */}
                {title && <ToastTitle>{title}</ToastTitle>}
              </div>
              {/* eslint-disable-next-line @typescript-eslint/strict-boolean-expressions */}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
